import { Col, Container, Row } from "@emanprague/ppaskit";
import iconSupport from "@emanprague/ppaskit/dist/assets/icons/Support.svg";
import React from "react";
import WecomaButton from "components/WecomaButton";

interface Props {
  translateFunc: (translateCode: string) => string;
}

export default class extends React.PureComponent<Props> {
  render() {
    return (
      <div className="pre-auth-footer bg-white py-3 mt-3 px-3">
        <WecomaButton className="pre-auth-footer__button" label={this.props.translateFunc("profile.common.cookies_settings")} />
        <Container>
          <Row noGutters className="align-items-center justify-content-center">
            <Col xs="auto">
              <img src={iconSupport} className="mr-4" role="presentation" />
            </Col>
            <Col xs={true} sm="auto">
              {this.props.translateFunc("profile.common.hint_text")}{" "}
              <a
                href={"tel:+420" + this.props.translateFunc("profile.common.hint_phone").replace(/\s/g, "")}
                className="text-body font-weight-bold link-underline-hover">
                {this.props.translateFunc("profile.common.hint_phone")}
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
